/* Chat */
$(function () {
    $('[data-chat-toggle="toggle"]').click(() => {
        $('.lena-chat-overlay').toggle();
    });
});
/* End of Chat */
